import $ from 'jquery';
export default function int_form() {
  	
	if( $(".tab-step").length ){
		$(".tab-step").click(function(e){
			e.preventDefault();
			let _target = $(this).data("target");
			let target = $("#" + _target + " a")
			if(target){
				target[0].click();
			}
			
		});
	}
	
	if( $(".ff-button.bt-next").length ){
		$(".ff-button.bt-next").click(function(e){
			e.preventDefault();
			let _target = $(this).data("id");
			let target = $(".fui-page[data-id='" + _target + "'] .fui-submit");
			if(target){
				target[0].click();
			}
		});
	}
	if( $(".ff-button.bt-prev").length ){
		$(".ff-button.bt-prev").click(function(e){
			e.preventDefault();
			let _target = $(this).data("id");
			let target = $(".fui-page[data-id='" + _target + "'] .fui-prev");
			if(target){
				target[0].click();
			}
		});
	}
	if( $("input[type='file'].fui-input").length ){
		let file_inputs =  $("input[type='file'].fui-input");
		file_inputs.each(function() { 
			var filenameview =   $("<span class='filenameview'>");
			$(this).parent().append(filenameview);
			$(this).change(function() { 
				var fileName = $(this).val();  
				
				if(fileName) {  
					$(this).addClass("hasfile");
					filenameview.html(fileName.split(/(\\|\/)/g).pop());
				} else {
					$(this).removeClass("hasfile");
					filenameview.html("");
				}  
			});
		});
		
	}
	$(".form-wrap.satisfaction .champs-satisfaction-informations input[type=radio]").change(function() {
		$(".form-wrap.satisfaction .fui-btn-wrapper.fui-btn-left button").css("display", "block")
	});
	$(document).ready(function() {
		var $txtArea = $('.form-wrap.satisfaction  textarea');
		var $chars   = $('.form-wrap.satisfaction .form-satisfaction-textarea ');
		var textMax = $txtArea.attr('data-max-chars');
		$chars.append(`<div class='fui-limit-text-custom'><span>Maximum ${textMax} caractères</span></div>`);
	
		$txtArea.on('keyup', countChar);
		
		function countChar() {
			var textLength = $txtArea.val().length;
			var textRemaining = textMax - textLength;
			$chars.children('.fui-limit-text-custom').html(`<span>Maximum ${textRemaining} caractères</span>`);
		};
	});

}

